import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { Store } from '@ngrx/store';
import { SaveMission } from '../../../store/actions/mission.actions';
import { InsuranceInterface } from '../../../models/insurance.interface';

@Component({
  selector: 'app-insurance',
  templateUrl: './insurance.component.html',
  styleUrls: ['./insurance.component.css'],
  standalone: false
})
export class InsuranceComponent implements OnInit {
  @Input()
  phoneNumber: string;

  @Input()
  procedureCode: string;

  environment = environment;
  isChecked: boolean;
  error: boolean;
  formSubmitted: boolean;

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.isChecked = false;
    this.error = false;
    this.formSubmitted = false;
  }
  
  cancel(){
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  confirmation(){
    this.error = false;
    if (this.isChecked && this.formSubmitted === false) {
      this.formSubmitted = true;
      const insuranceInterface = {phoneNumber: this.phoneNumber, step: 1} as InsuranceInterface;
      this.store.dispatch(new SaveMission(insuranceInterface, this.procedureCode));
    } else {
      this.error = true;
    }
  }
}
